// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    READ_APP_CONFIG_SUCCESS: 'READ_APP_CONFIG_SUCCESS',
    UPDATE_SELECTED_SAP_ENVIRONMENT: 'UPDATE_SELECTED_SAP_ENVIRONMENT'
});



// WEBPACK FOOTER //
// ./src/app-config/actions-list.js